import { Container } from "@cgc/ui/layout";
import Image from "next/image";
import React from "react";

type Props = {
  id: string;
  copy: React.ReactNode;
  backgroundImage: string;
  backgroundColor?: string;
  buttons?: React.ReactNode[];
  fluid?: boolean;
  hasCopy?: boolean;
};

const DefaultHero: React.FC<Props> = ({
  id,
  copy,
  backgroundImage,
  backgroundColor,
  fluid = true,
  buttons = [],
  hasCopy,
}) => {
  return (
    <Container
      id={id}
      fluid={fluid}
      {...{ ...(backgroundColor ? { style: { backgroundColor } } : null) }}
    >
      <div className="relative flex h-96 items-center">
        <Image
          src={backgroundImage}
          alt=""
          priority={true}
          fill
          className="object-cover"
        />
        {(hasCopy || buttons.length) && (
          <div className="text-cgc-blue absolute left-0 w-full bg-white/70 p-5 pr-20 md:max-w-md">
            <div className="pb-5">{copy}</div>
            {buttons.length > 0 && <div className="space-x-2">{buttons}</div>}
          </div>
        )}
      </div>
    </Container>
  );
};

export default DefaultHero;
